const PDFJS_DIST_VERSION = '2.12.313'
const PDFJS_DIST_CDN = `https://unpkg.com/pdfjs-dist@${PDFJS_DIST_VERSION}`

export const PDFJS_WORKER_URL = `${PDFJS_DIST_CDN}/build/pdf.worker.min.js`
export const PDFJS_CMAP_URL = `${PDFJS_DIST_CDN}/cmaps/`
